
import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Container } from 'reactstrap';
import AppNavbar from 'components/Nav';
import SideBar from 'components/SideBar';
import { HelmetProvider } from 'react-helmet-async';
import { MainPage } from 'features/main/MainPage';
import { useAuth } from '../helpers/authContext';
import { CarouselMain } from 'components/Carousel';
import { ProposalsListPage } from 'features/proposals/proposalsList/proposalsListPage';
import { ProposalDetailsPage } from 'features/proposals/proposalDetails/ProposalDetailsPage';
import WitnessesMainPage from 'features/witnesses/WitnessesMainPage';
import { PostPreviewPage } from 'features/posts/postPreviewPage';
import UserSettings from 'features/user/userSettings';
import { UserProfile } from 'features/user/userProfile';
import { get_carousel_items } from 'services/db-service';
import SearchResults from "features/main/SearchResults";
import { ScrollPage } from 'features/main/scrollPage';
import { Toaster } from "components/ui/toaster";
import { Playlist } from 'features/playlists/Playlist';
import { UserWallet } from 'features/user/userWallet';
import LeaderboardPage from 'features/leaderboard/LeaderboardPage';
import UploadResume from 'features/uploads/UploadResume';
import { FAQPage } from 'features/faq/FAQPage';
import { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
// import AppFooter from 'components/Footer';
import { PrivacyPolicy } from 'features/legal/PrivacyPolicy';
import { TermsOfService } from 'features/legal/TermsOfService';
import { AboutUs } from 'features/legal/AboutUs';
import { ScrollToTop } from 'components/ScrollToTop';
// import { getUploadState } from 'helpers/UploadState';
// import { getVideo } from 'helpers/UploadDB';

function App() {
  const location = useLocation();
  const { signedIn } = useAuth();
  const [carouselItems, setCarouselItems] = useState([]);
  useEffect(() => {
    (async () => {
      let carousel = await get_carousel_items();
      setCarouselItems(carousel || []);
    })();
  }, []);

  const isScrollPage =
    location.pathname === '/' ||
    location.pathname.startsWith('/clips');

  return (
    <div className={`speem-app-shell ${isScrollPage ? "is-video-feed" : ""} ${signedIn ? "is-logged-in" : "is-guest"}`}>
      <HelmetProvider>
        <SkeletonTheme baseColor="var(--skeleton-base)" highlightColor="var(--skeleton-highlight)">
          <React.Fragment>
            <ScrollToTop />
            <UploadResume />
            <AppNavbar />
            <SideBar />
            <Container className={`content-speem ${isScrollPage ? 'p-0 height-full' : ''}`}>
              <Routes>
                {/* Home & general categories */}
                <Route path="/" element={<><ScrollPage /></>} />
                <Route path="/clips/:author/:permlink" element={<ScrollPage />} />
                <Route path="/clips" element={<><ScrollPage /></>} />
                {/* <Route path="/" element={<><CarouselMain items={carouselItems} /><MainPage activeCategory="created" /></>} /> */}
                <Route path="/search" element={<SearchResults />} />
                <Route path="/trending" element={<>{carouselItems.length > 0 && <CarouselMain items={carouselItems} />}<MainPage activeCategory="trending" /></>} />
                <Route path="/new" element={<>{carouselItems.length > 0 && <CarouselMain items={carouselItems} />}<MainPage activeCategory="created" /></>} />
                <Route path="/new/:tag" element={<><MainPage activeCategory="created" /></>} />
                <Route path="/trending/:tag" element={<><MainPage activeCategory="trending" /></>} />
                <Route path="/foryou" element={<>{carouselItems.length > 0 && <CarouselMain items={carouselItems} />}<MainPage activeCategory="foryou" /></>} />
                <Route path="/foryou/:tag" element={<><MainPage activeCategory="foryou" /></>} />
                <Route path="/muted/:tag" element={<><MainPage activeCategory="muted" /></>} />
                <Route path="/top" element={<>{carouselItems.length > 0 && <CarouselMain items={carouselItems} />}<MainPage activeCategory="top" /></>} />
                <Route path="/top/alltime" element={<>{carouselItems.length > 0 && <CarouselMain items={carouselItems} />}<MainPage activeCategory="alltime" /></>} />
                <Route path="/top/:tag" element={<MainPage activeCategory="top" />} />
                <Route path="/top/alltime/:tag" element={<MainPage activeCategory="alltime" />} />
                <Route path="/following" element={<MainPage activeCategory="feed" />} />

                {/* Proposals & Witnesses */}
                <Route path="/proposals" element={<ProposalsListPage />} />
                <Route path="/proposal/:id" element={<ProposalDetailsPage />} />
                <Route path="/witnesses" element={<WitnessesMainPage />} />

                {/* User profile & post pages */}
                <Route path="/u/:username" element={<UserProfile />} />

                <Route path="/p/:username/:permlink" element={<PostPreviewPage />} />
                <Route path="/u/playlists/:username" element={<UserProfile tab="playlists" />} />
                <Route path="/u/blog/:username" element={<UserProfile tab="blog" />} />
                <Route path="/u/shared/:username" element={<UserProfile tab="shared" />} />
                <Route path="/u/comments/:username" element={<UserProfile tab="comments" />} />
                <Route path="/u/friends/:username" element={<UserProfile tab="friends" />} />
                <Route path="/u/communities/:username" element={<UserProfile tab="communities" />} />

                <Route path="/wallet" element={<UserWallet tab="balance" />} />
                <Route path="/wallet/:username" element={<UserWallet tab="balance" />} />
                <Route path="/wallet/:username/:tab" element={<UserWallet />} />

                <Route path="/playlist/:id" element={<Playlist />} />

                <Route path="/leaderboard" element={<LeaderboardPage tab="weekly" />} />
                <Route path="/leaderboard/weekly" element={<LeaderboardPage tab="weekly" />} />
                <Route path="/leaderboard/daily" element={<LeaderboardPage tab="daily" />} />
                <Route path="/leaderboard/daily/:date" element={<LeaderboardPage tab="daily" />} />
                <Route path="/leaderboard/:tab" element={<LeaderboardPage />} />
                <Route path="/faq" element={<FAQPage />} />

                <Route path="/settings" element={<UserSettings />} />
                <Route path="/settings/:tab" element={<UserSettings />} />

                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/about" element={<AboutUs />} />

              </Routes>
            </Container>
            {/* {!isScrollPage && <AppFooter />} */}
            <Toaster />
          </React.Fragment>
        </SkeletonTheme>
      </HelmetProvider>
    </div>
  );
}

export default App;
